import React, { useEffect } from 'react'
import { styles } from './TooltipStyles'
import { withStyles } from '@material-ui/core'
import InfoButton from '../icons/InfoButton'
import ReactTooltip from 'react-tooltip'
import { getTooltipAnchorArgs, getTooltipHorizontalPosition } from './position'

const Tooltip = props => {
  const { classes, tooltipId, tooltipText, offset, place = 'top', children, constrainToViewport = false } = props

  const alignToIcon = (position, ...args) => {
    const { target, node, place: currentPlace } = getTooltipAnchorArgs(...args)
    if (currentPlace !== 'top' && currentPlace !== 'bottom') return position
    const icon = target.getBoundingClientRect()
    const aligned = getTooltipHorizontalPosition(
      icon.left + icon.width / 2,
      node.getBoundingClientRect().width,
      document.documentElement.clientWidth,
    )
    let parent = node.parentElement
    while (parent && window.getComputedStyle(parent).transform === 'none') parent = parent.parentElement
    const parentLeft = parent ? parent.getBoundingClientRect().left : 0
    node.style.setProperty('--tooltip-arrow-left', `${aligned.arrowLeft}px`)
    return { ...position, left: aligned.left - parentLeft }
  }

  useEffect(() => {
    const handleScroll = () => ReactTooltip.hide()
    window.addEventListener('scroll', handleScroll, true)
    return () => window.removeEventListener('scroll', handleScroll, true)
  }, [])

  return (
    <div className={classes.tooltipWrap}>
      {children ? (
        <span data-for={tooltipId} data-tip={tooltipText}>
          {children}
        </span>
      ) : (
        <InfoButton dataFor={tooltipId} dataTip={tooltipText} />
      )}
      <ReactTooltip
        className={`${classes.tooltip} ${constrainToViewport ? classes.viewportAligned : ''}`}
        effect="solid"
        place={place}
        html
        {...(offset && { offset })}
        type="dark"
        id={tooltipId}
        {...(constrainToViewport && { overridePosition: alignToIcon })}
      />
    </div>
  )
}

export default withStyles(styles)(Tooltip)
